$(document).ready(function() {
    function updateStickyNavbar() {
        $('.navbar-sticky').each(function() {
            const navbar_top = $(this).data('start-top');
            if (window.pageYOffset >= navbar_top) {
                $(this).addClass('sticky');
            } else {
                $(this).removeClass('sticky');
            }
        });
    }

    $(window).on('scroll', updateStickyNavbar);
    $('.navbar-sticky').each(function() {
        $(this).data('start-top', $(this).offset().top - 100);
    });

    updateStickyNavbar();
});
